import { Carousel } from "primereact/carousel"
import { Link } from "@inertiajs/react"
import { SafeImage } from "@/Components/Common/SafeImage"
import { Clock, TrendingUp } from "lucide-react"

const responsiveOptions = [
    { breakpoint: "1280px", numVisible: 4, numScroll: 1 },
    { breakpoint: "1140px", numVisible: 3, numScroll: 1 },
    { breakpoint: "900px", numVisible: 2, numScroll: 1 },
    { breakpoint: "620px", numVisible: 1, numScroll: 1 },
]

const brandTemplate = (brand) => (
    <Link
        href={
            brand.published_at
                ? `/${brand.slug}`
                : `/auctions?brands[]=${encodeURIComponent(brand.slug)}`
        }
        className="flex flex-col items-center w-full"
    >
        <div className="m-2 flex w-[286px] flex-col items-center justify-center overflow-hidden rounded-lg border transition-shadow hover:shadow-md">
            <div className="h-[200px] relative w-full overflow-hidden bg-gray-100">
                <SafeImage
                    images={brand.latest_image ? [brand.latest_image] : []}
                    className="object-cover w-full h-full"
                    placeholderSeed={brand.id}
                />
                <div className="absolute bottom-0 flex items-center justify-between w-full px-2 py-2 text-xs text-white bg-black/70">
                    <div className="flex flex-row items-center gap-2">
                        <Clock color="red" className="w-4 h-4" />
                        <span>{brand.live_count ?? 0} active</span>
                    </div>
                    <div className="flex flex-row items-center gap-2">
                        <TrendingUp color="green" className="w-5 h-5" />
                        <span>{brand.sold_count ?? 0} sold</span>
                    </div>
                </div>
            </div>
            <span className="flex h-12 flex-col items-center justify-center text-[15px] font-semibold">
                {brand.name}
            </span>
        </div>
    </Link>
)

export default function BrandsCarousel({ brands }) {
    return (
        <div className="max-w-full -mt-4 xl:max-w-7xl">
            <Carousel
                value={brands}
                numVisible={4}
                numScroll={1}
                responsiveOptions={responsiveOptions}
                itemTemplate={brandTemplate}
                showIndicators={false}
            />
        </div>
    )
}
